import React, {
  useState,
  useRef,
  useEffect,
  useContext,
  useCallback,
} from "react";
import { Dropdown } from "../../../shadcn/components/custom/Dropdown";
import { useRouter } from "next/router";
import { Input } from "../../../shadcn/components/ui/input";
import { Switch } from "../../../shadcn/components/ui/switch";
import VerifiedHammer from "../../../icons/VerifiedHammer";
import CaretRight from "../../../icons/CaretRight";
import CaretLeft from "../../../icons/CaretLeft";
import ChevronUpSvg from "../../../icons/ChevronUpSvg";
import ChevronDownSvg from "../../../icons/ChevronDownSvg";
import PriceRangeSelector from "./PriceRangeSelector";
import MagnifyingGlassIcon from "../../../icons/MagnifyingGlassIcon";

import {
  Popover,
  PopoverTrigger,
  PopoverContent,
} from "../../../shadcn/components/ui/popover";

import { Calendar } from "../../../shadcn/components/ui/calendar";
import { Checkbox } from "../../../shadcn/components/ui/checkbox";
import { Context, getSearchResults, payloadToUrl } from "services";
import Dot from "../../../icons/Dot";
import { Button } from "../../../shadcn/components/ui/button";
interface FilterSectionWebProps {
  handleClearFilters: any;
}

export default function FilterSectionWeb({
  handleClearFilters,
}: FilterSectionWebProps) {
  const router = useRouter();
  const { searchForm }: any = useContext(Context);

  const [assetTypeOptions, setAssetTypeOptions] = useState<any[]>([]);

  const filterData = (dataToFilter: any) => {
    return (dataToFilter || []).map((data: any) => ({
      label: data?.parent?.asset_type_name,
      value: data?.parent?.asset_type_slug,
    }));
  };

  const getFilterForSubAssetType = (searchForm: any) => {
    const filters = [];
    if (searchForm?.value?.asset_type?.value) {
      const currentFilterString = `dump.asset.asset_type_slug:=${searchForm?.value?.asset_type?.value}`;
      filters.push(currentFilterString);
    }
    return filters;
  };

  const fetchOptions = async (): Promise<any[]> => {
    const initialData: any = await getSearchResults({
      searches: [
        {
          query_by: "",
          collection: "properties",
          q: "*",
          facet_by: "dump.asset.asset_type_name,dump.asset.asset_type_slug,",
          facet_return_parent:
            "dump.asset.asset_type_name,dump.asset.asset_type_slug,",
          filter: "true",
          max_facet_values: "500",
          infix: "always",
        },
        {
          query_by: "",
          collection: "properties",
          q: "*",
          facet_by:
            "dump.asset.sub_asset_type_name,dump.asset.sub_asset_type_slug",
          facet_return_parent:
            "dump.asset.sub_asset_type_name,dump.asset.sub_asset_type_slug",
          filter: "true",
          filter_by: getFilterForSubAssetType(searchForm).join(" && "),
          max_facet_values: "500",
          infix: "always",
        },
      ],
    });

    return (
      initialData?.results?.map((result: any) => ({
        group: "popular",
        data: filterData(result?.facet_counts?.[0]?.counts),
      })) || []
    );
  };

  useEffect(() => {
    const initializeOptions = async () => {
      const data = await fetchOptions();
      setAssetTypeOptions(data[0]?.data || []);
    };
    initializeOptions();
  }, [searchForm.value.asset_type]);

  const scheduleData = [
    { label: "Scheduled ", value: "dated" },
    { label: "Upcoming ", value: "undated" },
    { label: "Private Treaty", value: "private_treaty" },
  ];

  const propertyListingData = [
    { label: "Auction Properties ", value: "dated" },
    { label: "Private Properties ", value: "undated" },
  ];

  const handleSelectedScheduleOption = (value: any) => {
    searchForm.setField("filter_by", value);
  };

  const handleListingTypeOption = (value: any) => {
    if (value?.value === "dated") {
      window.location.href = "/auction-properties";
    } else {
      window.location.href =
        searchForm.value.city.value === ""
          ? "/private-properties"
          : `/private-properties?city=${searchForm.value.city.value}`;
    }
  };

  // const privateSaleData = [
  //   { label: "Private Treaty (By Banker)", value: "private_treaty" },
  //   { label: "Private Property (By Individual)", value: "private_property" },
  // ];
  const handlesPrivateSaleOption = (value: any) => {
    searchForm.setField("filter_by", value);
  };

  const [showRightArrow, setShowRightArrow] = useState(false);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScrollCheck = () => {
      const container = scrollContainerRef.current;
      if (container) {
        setShowRightArrow(
          container.scrollWidth > container.clientWidth &&
            container.scrollLeft <
              container.scrollWidth - container.clientWidth - 1
        );
        setShowLeftArrow(container.scrollLeft > 0);
      }
    };

    handleScrollCheck();
    window.addEventListener("resize", handleScrollCheck);

    // Listen for scroll changes
    const container = scrollContainerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScrollCheck);
    }

    return () => {
      window.removeEventListener("resize", handleScrollCheck);
      if (container) {
        container.removeEventListener("scroll", handleScrollCheck);
      }
    };
  }, []);

  const handleScrollToEnd = () => {
    const container = scrollContainerRef.current;
    if (container) {
      container.scrollTo({
        left: container.scrollWidth,
        behavior: "smooth",
      });
    }
  };

  const handleScrollToStart = () => {
    const container = scrollContainerRef.current;
    if (container) {
      container.scrollTo({
        left: 0,
        behavior: "smooth",
      });
    }
  };

  const dataSource: () => Promise<any> = () => {
    return Promise.resolve(assetTypeOptions);
  };

  const handleSetSelectedOption = (item: any) => {
    // setSelectedOption(item);
    searchForm.setField("asset_type", item);
    searchForm.setField("sub_asset_type", "");
  };

  const auctionVerifiedData = [
    { label: "Verified Property", value: "auction_verified" },
  ];

  const handleSwitchChange = (checked: boolean) => {
    const filterField = searchForm.getField("filter_by");
    if (checked) {
      // if (filterField && filterField !== "") {
      searchForm.setField("ab_verified", {
        label: "Verified Property",
        value: "auction_verified",
      });
      // } else {
      //   searchForm.setField("filter_by", {
      //     label: "Verified Property",
      //     value: "auction_verified",
      //   });
      // }
    } else {
      const isFilterVerified =
        filterField &&
        auctionVerifiedData?.some((item) => filterField.value === item.value);

      if (isFilterVerified) {
        searchForm.setField("filter_by", "");
      }
      searchForm.setField("ab_verified", "");
      // } else {
      // }
    }
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    searchForm.setField("listing_id_query", value);
  };

  // useEffect(() => {
  //   if (searchForm.value.filter_by.value === "undated") {
  //     setSelectedScheduleOption(scheduleData[1]);
  //   } else if (searchForm.value.filter_by.value === "dated") {
  //     setSelectedScheduleOption(scheduleData[0]);
  //   } else if (searchForm.value.filter_by.value === "private_treaty") {
  //     setPrivateSaleOption(privateSaleData[0]);
  //   } else if (searchForm.value.filter_by.value === "auction_verified") {
  //     setIsSwitchChecked(true);
  //   }
  // }, [searchForm.value.filter_by]);

  // const handleClearFilters = () => {
  //   // Reset all filter fields
  //   searchForm.setField("asset_type", "");
  //   searchForm.setField("sub_asset_type", "");
  //   searchForm.setField("state", "");
  //   searchForm.setField("city", "");
  //   searchForm.setField("locality", "");
  //   searchForm.setField("reserve_price", "");
  //   searchForm.setField("institutes", "");
  //   searchForm.setField("filter_by", "");
  //   searchForm.setField("sort_by", "");
  //   searchForm.setField("auction_start_date_unix_timestamp", "");
  //   searchForm.setField("listing_id_query", "");
  //   searchForm.setField("ab_verified", "");
  //   payloadToUrl(router, searchForm.value);
  // };

  // const clearFilterHandler = () => {
  //   handleClearFilters();
  // };

  // console.log("searchForm---->>", searchForm.value);
  // console.log(
  //   "searchForm.getField(",
  //   searchForm.getField("filter_by") !== ""
  //     ? auctionVerifiedData.find(
  //         (item) => searchForm.getField("filter_by").value === item.value
  //       )
  //       ? true
  //       : searchForm.getField("ab_verified") &&
  //         searchForm.getField("ab_verified") !== ""
  //       ? true
  //       : false
  //     : searchForm.getField("ab_verified") &&
  //       searchForm.getField("ab_verified") !== ""
  //     ? true
  //     : false,
  //   auctionVerifiedData.find(
  //     (item) => searchForm.getField("filter_by").value === item.value
  //   ),
  //   searchForm.getField("ab_verified") !== "",
  //   searchForm.getField("ab_verified")
  // );
  return (
    <section className="min-h-[115px] w-full bg-white sticky hidden lg:block top-10 z-30 pt-9 py-4 shadow-sm">
      <div className="relative flex px-customPadding w-full 2xl:w-[1340px] 2xl:mx-auto 2xl:px-0">
        <div className="flex items-center flex-1 overflow-x-auto relative ">
          <div
            ref={scrollContainerRef}
            className="flex gap-x-5 gap-y-2 xl:gap-y-3 items-center flex-wrap "
          >
            {/* {showLeftArrow && (
              <button
                className="absolute left-0 top-1/2 transform -translate-y-1/2 bg-gradient-to-r from-white to-[#ffffffda] pr-4 pl-2 py-3 shadow-lg z-40"
                onClick={handleScrollToStart}
              >
                <CaretLeft />
              </button>
            )} */}

            <div className="">
              <Input
                type="text"
                placeholder="Search ID"
                value={
                  searchForm.getField("listing_id_query")
                    ? searchForm.getField("listing_id_query") !== ""
                      ? searchForm.getField("listing_id_query")
                      : ""
                    : ""
                }
                onChange={handleInputChange}
                className="max-w-[130px] xl:max-w-[154px] rounded-lg border-brand-borderGrey text-sm focus:border-none focus:border-brand-borderGrey"
              />
            </div>

            <div key={1}>
              <Dropdown
                dataSource={dataSource}
                defaultSelected={
                  searchForm.getField("asset_type") !== ""
                    ? searchForm.getField("asset_type")
                    : undefined
                }
                selectIdentifier={true}
                onChange={(value: any) => handleSetSelectedOption(value)}
                valueKey="value"
                placeholder="Asset type"
                styles={{
                  dropdownItemsClass: "text-brand-borderGrey",
                  hoverBgColor: "focus:bg-brand-lightPink",
                  hoverTextColor: "focus:text-brand-borderGrey",
                  outerContainer:
                    "border-[1px] border-brand-borderGrey hover:border-brand-orange min-w-[130px] xl:min-w-[170px] rounded-lg text-sm leading-normal font-openSans text-brand-textBlack px-4",
                }}
              />
            </div>
            <div key={2}>
              <PropertySubTypeFilter />
            </div>

            <div key={3}>
              <PriceRangeBasicDropDown />
            </div>

            <div key={4}>
              <DateSelector />
            </div>
            <div key={5}>
              <InstitutesFilter />
            </div>
            <div key={6}>
              <Dropdown
                dataSource={() => {
                  return Promise.resolve(scheduleData);
                }}
                defaultSelected={
                  searchForm.getField("filter_by") !== ""
                    ? scheduleData.find(
                        (item) =>
                          searchForm.getField("filter_by").value === item.value
                      )
                    : undefined
                }
                selectIdentifier={true}
                onChange={(value: any) => handleSelectedScheduleOption(value)}
                valueKey="value"
                placeholder="Schedule"
                styles={{
                  dropdownItemsClass: "text-brand-borderGrey",
                  hoverBgColor: "focus:bg-brand-lightPink",
                  hoverTextColor: "focus:text-brand-borderGrey",
                  outerContainer:
                    "border-[1px] border-brand-borderGrey hover:border-brand-orange min-w-[130px] xl:min-w-[154px] rounded-lg text-sm leading-normal font-openSans text-brand-textBlack px-4",
                }}
              />
            </div>
            {process.env.NEXT_PUBLIC_PYP_ENABLE === "true" ? (
              <div key={7}>
                <Dropdown
                  dataSource={() => {
                    return Promise.resolve(propertyListingData);
                  }}
                  defaultSelected={undefined}
                  selectIdentifier={true}
                  onChange={(value: any) => handleListingTypeOption(value)}
                  valueKey="value"
                  placeholder="Auction Properties"
                  styles={{
                    dropdownItemsClass: "text-brand-borderGrey",
                    hoverBgColor: "focus:bg-brand-lightPink",
                    hoverTextColor: "focus:text-brand-borderGrey",
                    outerContainer:
                      "border-[1px] border-brand-borderGrey hover:border-brand-orange min-w-[130px] xl:min-w-[154px] rounded-lg text-sm leading-normal font-openSans text-brand-textBlack px-4",
                  }}
                />
              </div>
            ) : (
              <></>
            )}

            {/* <div key={7}>
              <Dropdown
                dataSource={() => {
                  return Promise.resolve(privateSaleData);
                }}
                defaultSelected={
                  searchForm.getField("filter_by") !== ""
                    ? privateSaleData.find(
                        (item) =>
                          searchForm.getField("filter_by").value === item.value
                      )
                    : undefined
                }
                selectIdentifier={true}
                onChange={(value: any) => handlesPrivateSaleOption(value)}
                valueKey="value"
                placeholder="Private sale"
                styles={{
                  dropdownItemsClass: "text-brand-borderGrey",
                  hoverBgColor: "focus:bg-brand-lightPink",
                  hoverTextColor: "focus:text-brand-borderGrey",
                  outerContainer: `border-[1px] border-brand-borderGrey hover:border-brand-orange min-w-[130px] xl:min-w-[170px] rounded-lg text-sm leading-normal font-openSans text-brand-textBlack`,
                }}
              />
            </div> */}

            {/* Switch and Icon */}
            <div
              key={9}
              className="flex items-center gap-2 px-3 py-2 bg-[#F8F8F8] rounded-lg drop-shadow-sm"
            >
              <VerifiedHammer />
              <Switch
                checked={
                  searchForm.getField("filter_by") !== ""
                    ? auctionVerifiedData.find(
                        (item) =>
                          searchForm.getField("filter_by").value === item.value
                      )
                      ? true
                      : searchForm.getField("ab_verified") &&
                        searchForm.getField("ab_verified") !== ""
                      ? true
                      : false
                    : searchForm.getField("ab_verified") &&
                      searchForm.getField("ab_verified") !== ""
                    ? true
                    : false
                }
                onCheckedChange={handleSwitchChange}
              />
            </div>
          </div>
          {/* {showRightArrow && (
            <button
              className="absolute right-0 top-1/2 transform -translate-y-1/2 bg-gradient-to-r from-[#ffffffd5] to-white pl-4 pr-0 py-3 shadow-lg"
              onClick={handleScrollToEnd}
            >
              <CaretRight />
            </button>
          )} */}
        </div>
        <Button
          className="ml-5 px-5 text-xs py-[9px]"
          onClick={() => {
            handleClearFilters();
          }}
        >
          Clear Filter
        </Button>
      </div>
    </section>
  );
}

const PriceRangeBasicDropDown = () => {
  const { searchForm }: any = useContext(Context);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedRange, setSelectedRange] = useState<
    [number | null, number | null]
  >([0, null]);

  // Format numbers into Indian currency format
  const formatIndianCurrency = (number: any) => {
    if (number || number === 0) {
      if (number >= 1_00_00_000)
        return `${(number / 1_00_00_000).toFixed(1)}Cr`;
      if (number >= 1_00_000) return `${(number / 1_00_000).toFixed(1)}L`;
      if (number >= 1_000) return `${(number / 1_000).toFixed(1)}K`;
      return number.toString();
    }
    return null;
  };

  // Update the reserve price field when the selected range changes
  useEffect(() => {
    const reservePrice = searchForm.value.reserve_price;
    if (reservePrice) {
      const [minPrice, maxPrice] = reservePrice.split("-").map(Number);
      setSelectedRange([minPrice * 100000, maxPrice * 100000]);
    } else {
      setSelectedRange([0, null]);
    }
  }, [searchForm.value.reserve_price]);

  useEffect(() => {
    const updateReservePrice = () => {
      if ((selectedRange[0] || selectedRange[0] === 0) && selectedRange[1]) {
        const formattedRange = `${Math.floor(
          selectedRange[0] / 100000
        )}-${Math.floor(selectedRange[1] / 100000)}`;
        if (isOpen && selectedRange[0] < selectedRange[1]) {
          searchForm.setField("reserve_price", formattedRange);
        }
      }
    };

    const handler = setTimeout(updateReservePrice, 300);
    return () => clearTimeout(handler);
  }, [selectedRange, isOpen]);

  return (
    <Popover onOpenChange={setIsOpen} open={isOpen}>
      <PopoverTrigger asChild>
        <main
          className={`cursor-pointer border-[1px] ${
            isOpen ? "border-brand-orange" : "border-brand-borderGrey"
          } hover:border-brand-orange min-w-[130px] xl:min-w-[154px] rounded-lg pl-4 pr-2 py-[9px]`}
          onClick={() => setIsOpen((prev) => !prev)}
        >
          <div className="flex items-center justify-between">
            {searchForm.getField("reserve_price") &&
            searchForm.getField("reserve_price") !== "" ? (
              <p className="text-[13px] font-openSans text-brand-textBlack flex items-center whitespace-nowrap">
                <span className="mr-3">
                  <Dot />
                </span>
                ₹{formatIndianCurrency(selectedRange[0])} - ₹
                {formatIndianCurrency(selectedRange[1])}
              </p>
            ) : (
              <p className="text-[14px] font-openSans text-brand-textBlack flex items-center whitespace-nowrap">
                Price Range
              </p>
            )}
            <div className="pr-2 pl-2">
              {isOpen ? (
                <ChevronUpSvg width={14} height={14} fill="#7D7D7D" />
              ) : (
                <ChevronDownSvg width={14} height={14} fill="#7D7D7D" />
              )}
            </div>
          </div>
        </main>
      </PopoverTrigger>
      <PopoverContent className="min-w-[439px]">
        <PriceRangeSelector
          range={[0, 2600000000]}
          defaultSelectedRange={selectedRange}
          minStepsBetweenThumbs={500}
          step={500}
          setSelectedRange={setSelectedRange}
        />
      </PopoverContent>
    </Popover>
  );
};

const DateSelector = () => {
  const { searchForm }: any = useContext(Context);
  const [isOpen, setIsOpen] = useState(false);
  const [startDate, setStartDate] = useState<Date | any>(null);
  const [endDate, setEndDate] = useState<Date | any>(null);
  const [dateRangeValue, setDateRangeValue] = useState<string | null>(null);

  const toggleDropdown = () => setIsOpen((prev) => !prev);
  const dateToUnixTimestamp = (date: Date | undefined): number | null => {
    return date ? Math.floor(date.getTime()) : null;
  };

  const validateAndPrepareSearch = useCallback(() => {
    if (startDate && endDate && startDate > endDate) {
      // setErrorMessage("Start date cannot be later than End date");
      return null;
    } else {
      // setErrorMessage("");
    }
    const startTimestamp = dateToUnixTimestamp(startDate);
    const endTimestamp = dateToUnixTimestamp(endDate);
    if (startTimestamp && endTimestamp) {
      setDateRangeValue(`${startTimestamp}-${endTimestamp}`);
    } else return setDateRangeValue(null);
  }, [startDate, endDate]);

  useEffect(() => {
    validateAndPrepareSearch();
    if (dateRangeValue) {
      searchForm.setField("auction_start_date_unix_timestamp", dateRangeValue);
    }
  }, [dateRangeValue, startDate, endDate]);

  useEffect(() => {
    const auctionDateRange = searchForm.getField(
      "auction_start_date_unix_timestamp"
    );
    if (!auctionDateRange || auctionDateRange === "") {
      setStartDate(null);
      setEndDate(null);
      setDateRangeValue(null);
      return;
    }
  }, [searchForm.value.auction_start_date_unix_timestamp]);

  const handleDateSelect = (range: { from?: Date; to?: Date }) => {
    if (!range) return;

    const { from: selectedStartDate, to: selectedEndDate } = range;

    if (startDate && endDate) {
      const midpointTimestamp = (startDate.getTime() + endDate.getTime()) / 2;
      if (
        selectedStartDate &&
        selectedStartDate.getTime() <= midpointTimestamp
      ) {
        setStartDate(selectedStartDate);
      }
      if (selectedEndDate && selectedEndDate.getTime() >= midpointTimestamp) {
        setEndDate(selectedEndDate);
      } else if (
        selectedEndDate &&
        selectedEndDate.getTime() < midpointTimestamp
      ) {
        setStartDate(selectedEndDate);
      }
    } else if (startDate && !endDate) {
      if (
        selectedStartDate &&
        selectedStartDate.getTime() < startDate.getTime()
      ) {
        setEndDate(startDate);
        setStartDate(selectedStartDate);
      } else if (
        selectedEndDate &&
        selectedEndDate.getTime() >= startDate.getTime()
      ) {
        setEndDate(selectedEndDate);
      }
    } else {
      setStartDate(selectedStartDate || null);
      setEndDate(selectedEndDate || null);
    }
  };

  const formatDate = (date: Date | null): string => {
    if (!date) return "";
    const day = date.getDate().toString().padStart(2, "0");
    const month = date.toLocaleString("default", { month: "short" });
    const year = date.getFullYear().toString().slice(-2);
    return `${day}/${month}/${year}`;
  };

  return (
    <Popover onOpenChange={setIsOpen} open={isOpen}>
      <PopoverTrigger asChild>
        <main
          className={`cursor-pointer border-[1px] ${
            isOpen ? "border-brand-orange" : "border-brand-borderGrey"
          } hover:border-brand-orange min-w-[190px] xl:min-w-[214px] rounded-lg pl-4 pr-2 py-[9px]`}
          onClick={toggleDropdown}
        >
          <div className="flex items-center justify-between">
            <p className="text-sm font-openSans text-brand-textBlack flex items-center">
              {startDate && endDate && (
                <span className="mr-3">
                  <Dot />
                </span>
              )}
              {`${formatDate(startDate) || "Start date"} - ${
                formatDate(endDate) || "End date"
              }`}
            </p>
            <div className="pr-2">
              {isOpen ? (
                <ChevronUpSvg width={14} height={14} fill="#7D7D7D" />
              ) : (
                <ChevronDownSvg width={14} height={14} fill="#7D7D7D" />
              )}
            </div>
          </div>
        </main>
      </PopoverTrigger>
      <PopoverContent className="flex w-auto flex-col space-y-2 px-[51px] pt-7">
        <div className="w-full bg-[#EEE] grid grid-cols-2 justify-between rounded-lg py-4 mb-4">
          <div className="flex flex-col justify-center items-center border-r-[1px] border-brand-textLightGrey">
            <div className="text-[10px] font-openSans text-brand-bgBlack">
              Start date
            </div>
            <div className="text-xs font-openSans text-brand-bgBlack">
              {startDate ? formatDate(startDate) : "Add dates"}
            </div>
          </div>
          <div className="flex flex-col justify-center items-center">
            <div className="text-[10px] font-openSans text-brand-bgBlack">
              End date
            </div>
            <div className="text-xs font-openSans text-brand-bgBlack">
              {endDate ? formatDate(endDate) : "Add dates"}
            </div>
          </div>
        </div>
        <div className="rounded-md border">
          <Calendar
            initialFocus
            mode="range"
            selected={{
              from: startDate || undefined,
              to: endDate || undefined,
            }}
            onSelect={(range: { from?: Date; to?: Date } | undefined) => {
              if (range) {
                handleDateSelect(range);
              }
            }}
            numberOfMonths={2}
          />
        </div>
      </PopoverContent>
    </Popover>
  );
};

const InstitutesFilter = () => {
  const { searchForm }: any = useContext(Context);
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(searchTerm);
  const [options, setOptions] = useState<any[]>([]);
  const toggleDropdown = () => setIsOpen((prev) => !prev);
  const filterData = (dataToFilter: any) =>
    (dataToFilter || []).map((data: any) => ({
      label: data.parent.bank_name,
      value: data.parent.bank_slug,
    }));

  const fetchOptions = async (): Promise<any[]> => {
    const initialData: any = await getSearchResults({
      searches: [
        {
          collection: "properties",
          q: "*",
          filter_by: `${
            searchForm.value.city.value
              ? `status:active && dump.location.city_name:${searchForm.value.city.label}`
              : "status:active"
          }`,
          filter: "true",
          facet_by: "dump.bank.bank_slug",
          facet_return_parent: "dump.bank.bank_slug",
          max_facet_values: "500",
          per_page: 0,
        },
      ],
    });

    return (
      initialData?.results?.map((result: any) => ({
        group: "popular",
        data: filterData(result.facet_counts?.[0]?.counts),
      })) || []
    );
  };

  useEffect(() => {
    const initializeOptions = async () => {
      const data = await fetchOptions();
      setOptions(data[0]?.data || []);
    };
    initializeOptions();
  }, [searchForm.value.city]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 300);

    return () => clearTimeout(handler);
  }, [searchTerm]);

  const handleCheckboxChange = (
    bank: { label: string; value: string },
    isChecked: boolean
  ) => {
    const prev = searchForm.getField("institutes");

    if (Array.isArray(prev) && isChecked) {
      const selectedPrev = prev.filter(
        (item: any) => item?.value !== bank?.value
      );
      selectedPrev.push(bank);
      searchForm.setField("institutes", selectedPrev);
    } else if (Array.isArray(prev) && !isChecked) {
      const selectedPrev = prev.filter(
        (item: any) => item?.value !== bank?.value
      );
      if (selectedPrev.length > 0) {
        searchForm.setField("institutes", selectedPrev);
      } else {
        searchForm.setField("institutes", "");
      }
    } else if (isChecked) {
      searchForm.setField("institutes", [bank]);
    }
  };

  const filteredOptions = options.filter((bank: any) =>
    bank.label.toLowerCase().includes(debouncedSearchTerm.toLowerCase())
  );

  return (
    <Popover onOpenChange={setIsOpen} open={isOpen}>
      <PopoverTrigger asChild>
        <main
          className={`cursor-pointer border-[1px] ${
            isOpen ? "border-brand-orange" : "border-brand-borderGrey"
          } hover:border-brand-orange min-w-[130px] xl:min-w-[154px] rounded-lg pl-4 pr-2 py-[9px]`}
          onClick={toggleDropdown}
        >
          <div className="flex items-center justify-between">
            <p className="text-sm font-openSans text-brand-textBlack flex items-center">
              {Array.isArray(searchForm.getField("institutes")) &&
                searchForm.getField("institutes").length > 0 && (
                  <span className="mr-3">
                    <Dot />
                  </span>
                )}
              Institutes
            </p>
            <div className="pr-2 pl-2">
              {isOpen ? (
                <ChevronUpSvg width={14} height={14} fill={"#7D7D7D"} />
              ) : (
                <ChevronDownSvg width={14} height={14} fill={"#7D7D7D"} />
              )}
            </div>
          </div>
        </main>
      </PopoverTrigger>
      <PopoverContent className="min-w-[203px]">
        <div className="min-w-[203px]">
          <div className="flex py-2 items-center">
            <MagnifyingGlassIcon />
            <Input
              type="text"
              placeholder="Search"
              className="h-5 border-none rounded-sm text-xs ring-none outline-none focus:border-0 focus:outline-none px-0 ml-3"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <div className="max-h-[251px] overflow-scroll border-t-[1px] py-4">
            {filteredOptions.length > 0 ? (
              filteredOptions.map((bank, index) => (
                <div key={index} className="flex items-center">
                  <Checkbox
                    checkIconClassName="text-brand-bgBlack"
                    className="data-[state=checked]:bg-[#EEEEEE] border-brand-bgBlack"
                    id={`bank-${index}`}
                    checked={
                      Array.isArray(searchForm.getField("institutes")) &&
                      searchForm
                        .getField("institutes")
                        ?.some((item: any) => item.value === bank.value) // Check if the current bank is selected
                    }
                    onCheckedChange={
                      (isChecked: boolean) =>
                        handleCheckboxChange(bank, isChecked) // Pass the entire bank object
                    }
                  />
                  <label
                    htmlFor={`bank-${index}`}
                    className="text-sm pl-2 py-1 font-openSans capitalize tracking-wider text-brand-textLightGrey"
                  >
                    {bank.label}
                  </label>
                </div>
              ))
            ) : (
              <div className="text-sm text-gray-500 pl-2 py-3">
                No results found
              </div>
            )}
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
};

const PropertySubTypeFilter = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { searchForm }: any = useContext(Context);
  const initialCheckedItems = searchForm.value.asset_type
    ? Array.isArray(searchForm.value.sub_asset_type)
      ? searchForm.value.sub_asset_type
      : typeof searchForm.value.sub_asset_type === "object" &&
        searchForm.value.sub_asset_type !== ""
      ? [searchForm.value.sub_asset_type]
      : []
    : [];

  // const [checkedItems, setCheckedItems] = useState<
  //   { label: string; value: string }[]
  // >([]);

  const [assetSubTypeOptions, setAssetSubTypeOptions] = useState<any[]>([]);

  const filterData = (dataToFilter: any) => {
    return (dataToFilter || []).map((data: any) => ({
      label: data.parent.sub_asset_type_name,
      value: data.parent.sub_asset_type_slug,
    }));
  };

  const getFilterForSubAssetType = (searchForm: any) => {
    const filters = [];
    if (searchForm.value.asset_type.value) {
      const currentFilterString = `dump.asset.asset_type_slug:=${searchForm.value.asset_type.value}`;
      filters.push(currentFilterString);
    }
    return filters;
  };
  //checkedItems?.[bank.value]?.booked
  //searchForm.setField("institutes", selected);
  const fetchOptions = async (): Promise<any[]> => {
    const initialData: any = await getSearchResults({
      searches: [
        {
          query_by: "",
          collection: "properties",
          q: "*",
          facet_by:
            "dump.asset.sub_asset_type_name,dump.asset.sub_asset_type_slug",
          facet_return_parent:
            "dump.asset.sub_asset_type_name,dump.asset.sub_asset_type_slug",
          filter: "true",
          filter_by: getFilterForSubAssetType(searchForm).join(" && "),
          max_facet_values: "500",
          infix: "always",
        },
      ],
    });

    return (
      initialData?.results?.map((result: any) => ({
        group: "popular",
        data: filterData(result.facet_counts?.[0]?.counts),
      })) || []
    );
  };

  useEffect(() => {
    if (searchForm.value.asset_type.value) {
      const initializeOptions = async () => {
        const data = await fetchOptions();
        setAssetSubTypeOptions(data[0]?.data || []);
        // setCheckedItems(initialCheckedItems);
      };
      initializeOptions();
    } else {
      setAssetSubTypeOptions([]);
    }
  }, [searchForm.value.asset_type]);

  const toggleDropdown = () => setIsOpen((prev) => !prev);

  const handleCheckboxChange = (
    item: { label: string; value: string },
    isChecked: boolean
  ) => {
    // setCheckedItems((prevCheckedItems) => {
    //   const updatedCheckedItems = isChecked
    //     ? [...prevCheckedItems, item]
    //     : prevCheckedItems.filter(
    //         (checkedItem: { value: string }) => checkedItem.value !== item.value
    //       );
    //   // Update the search form field with the updated list
    //   searchForm.setField("sub_asset_type", updatedCheckedItems);
    //   return updatedCheckedItems;
    // });
    const updatedCheckedItems = isChecked
      ? [...initialCheckedItems, item]
      : initialCheckedItems.filter(
          (checkedItem: { value: string }) => checkedItem.value !== item.value
        );
    searchForm.setField("sub_asset_type", updatedCheckedItems);
  };

  return (
    <Popover onOpenChange={setIsOpen} open={isOpen}>
      <PopoverTrigger asChild>
        <main
          className={`cursor-pointer border-[1px] ${
            isOpen ? "border-brand-orange" : "border-brand-borderGrey"
          } hover:border-brand-orange min-w-[130px] xl:min-w-[160px] rounded-lg pl-4 pr-2 py-[9px]`}
          onClick={toggleDropdown}
        >
          <div className="flex items-center justify-between">
            <div className="text-sm font-openSans text-brand-textBlack capitalize overflow-hidden break-all max-h-5 flex items-center">
              {initialCheckedItems.length > 0 && (
                <span className="mr-3">
                  <Dot />
                </span>
              )}

              <span className="overflow-hidden text-ellipsis whitespace-nowrap capitalize">
                {initialCheckedItems.length > 0 ? (
                  <>
                    {initialCheckedItems[0].label}
                    {initialCheckedItems.length > 1 && (
                      <>,{initialCheckedItems[1].label.slice(0, 3)}...</>
                    )}
                  </>
                ) : (
                  "Sub Asset Type "
                )}
              </span>
            </div>
            <div className="pr-2 pl-2">
              {isOpen ? (
                <ChevronUpSvg width={14} height={14} fill={"#7D7D7D"} />
              ) : (
                <ChevronDownSvg width={14} height={14} fill={"#7D7D7D"} />
              )}
            </div>
          </div>
        </main>
      </PopoverTrigger>
      <PopoverContent className="min-w-[130px] xl:min-w-[160px] max-w-[244px]">
        <div className="max-h-[251px] overflow-scroll w-full">
          {assetSubTypeOptions.map((item, index) => (
            <div key={index} className="flex items-center">
              <Checkbox
                id={`asset-${index}`}
                checkIconClassName="text-brand-bgBlack"
                className="data-[state=checked]:bg-[#EEEEEE] border-brand-bgBlack"
                checked={initialCheckedItems?.some(
                  (checkedItem: any) => checkedItem.value === item.value
                )}
                onCheckedChange={(isChecked: boolean) =>
                  handleCheckboxChange(item, isChecked)
                }
              />
              <label
                htmlFor={`asset-${index}`}
                className="text-sm pl-2 py-1 font-openSans capitalize tracking-wider text-brand-textLightGrey"
              >
                {item.label}
              </label>
            </div>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};
